import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Table, Input } from "reactstrap";
import ExportJsonExcel from "js-export-excel";

const entero = (n) => new Intl.NumberFormat("en-US").format(n || 0);

// Lo que tienen publicado (o vendieron) en Mercado Libre y no esta en el catalogo
function SinAltaMeli({ URL, headers, cuentas, habilitado, error }) {
  const [datos, setDatos] = useState(null);
  const [cuenta, setCuenta] = useState("");
  const [vista, setVista] = useState("alta");
  const [busca, setBusca] = useState("");
  const [leyendo, setLeyendo] = useState("");

  const carga = () =>
    axios
      .get(`${URL}SinAlta${cuenta ? `?cuenta=${cuenta}` : ""}`, { headers })
      .then((r) => setDatos(r.data))
      .catch((e) => error(e, "No se pudo cargar"));

  useEffect(() => {
    carga();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuenta]);

  // Vuelve a leer las publicaciones de las cuentas prendidas (solo lectura)
  async function leeMeli() {
    const lista = cuentas.filter((c) => c.plataforma === "Mercado Libre" && c.modo !== "Apagado" && c.conectada && (!cuenta || c._id === cuenta));
    for (const c of lista) {
      setLeyendo(`Leyendo ${c.nombre}...`);
      try {
        await axios.post(`${URL}SincronizaPublicaciones/${c._id}`, {}, { headers });
      } catch (e) {
        error(e, `No se pudo leer ${c.nombre}`);
      }
    }
    setLeyendo("");
    await carga();
    Swal.fire({ icon: "success", title: "Publicaciones actualizadas", timer: 1800, showConfirmButton: false });
  }

  const filas = (datos ? datos.filas : []).filter((f) => {
    const q = busca.trim().toLowerCase();
    if (vista === "alta" && !f.porDarDeAlta) return false;
    if (vista === "amarrar" && f.porDarDeAlta) return false;
    return !q || `${f.sku} ${f.titulo}`.toLowerCase().includes(q);
  });

  function excel() {
    const hoja = filas.map((f) => ({
      SKU: f.sku,
      Titulo: f.titulo,
      Cuentas: f.cuentas.join(", "),
      Publicaciones: f.publicaciones.map((p) => p.id).join(", "),
      "Stock Meli": f.stockMeli,
      Precio: f.precio,
      "Piezas sin capturar": f.piezasVendidas,
      Motivo: f.motivo,
    }));
    new ExportJsonExcel({
      fileName: "Articulos Meli sin alta",
      datas: [{ sheetData: hoja, sheetName: "Sin alta", sheetFilter: Object.keys(hoja[0] || {}), sheetHeader: Object.keys(hoja[0] || {}) }],
    }).saveExcel();
  }

  const lectura = (datos ? datos.cuentas : [])
    .map((c) => `${c.nombre} ${c.ultimaLectura ? String(c.ultimaLectura).slice(0, 10) : "nunca"}`)
    .join(" · ");
  const total = datos ? datos.filas.length : 0;
  const porDarDeAlta = datos ? datos.resumen.porDarDeAlta : 0;

  return (
    <>
      <div className="intg-barra">
        <button className={`intg-chip ${vista === "alta" ? "activo" : ""}`} onClick={() => setVista("alta")}>
          Por dar de alta ({entero(porDarDeAlta)})
        </button>
        <button className={`intg-chip ${vista === "amarrar" ? "activo" : ""}`} onClick={() => setVista("amarrar")}>
          Ya existen, falta amarrar ({entero(total - porDarDeAlta)})
        </button>
        <Input bsSize="sm" type="select" value={cuenta} onChange={(e) => setCuenta(e.target.value)} style={{ width: 180 }}>
          <option value="">Todas las cuentas</option>
          {cuentas
            .filter((c) => c.plataforma === "Mercado Libre")
            .map((c) => (
              <option key={c._id} value={c._id}>
                {c.nombre}
              </option>
            ))}
        </Input>
        <Input bsSize="sm" placeholder="Buscar SKU o titulo" value={busca} onChange={(e) => setBusca(e.target.value)} style={{ width: 220 }} />
        <Button size="sm" color="success" disabled={!filas.length} onClick={excel}>
          Excel <i className="far fa-file-excel"></i>
        </Button>
        <Button size="sm" color="primary" disabled={!habilitado || !!leyendo} title={habilitado ? "Solo lee de Mercado Libre" : "Modo preparativo: no se jala nada"} onClick={leeMeli}>
          <i className="fas fa-sync"></i> {leyendo || "Leer Meli ahora"}
        </Button>
      </div>
      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>Ultima lectura: {lectura || "—"}. Se lee sola todos los dias a las 4:30.</div>
      {!datos ? (
        <div className="intg-vacio">Cargando...</div>
      ) : !filas.length ? (
        <div className="intg-vacio">
          <i className="fas fa-check-circle"></i>
          No hay articulos en esta vista.
        </div>
      ) : (
        <Table size="sm" striped borderless className="table-responsive-xl">
          <thead>
            <tr>
              <th>SKU en Meli</th>
              <th>Titulo</th>
              <th>Cuenta</th>
              <th>Publicaciones</th>
              <th style={{ textAlign: "right" }}>Stock Meli</th>
              <th style={{ textAlign: "right" }}>Precio</th>
              <th style={{ textAlign: "right" }}>Sin capturar</th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            {filas.slice(0, 1000).map((f, i) => (
              <tr key={`${f.sku}-${i}`}>
                <td>
                  <b>{f.sku || "Sin SKU"}</b>
                </td>
                <td style={{ fontSize: 12, maxWidth: 300 }}>{f.titulo}</td>
                <td style={{ fontSize: 12 }}>{f.cuentas.join(", ")}</td>
                <td style={{ fontSize: 12 }}>
                  {f.publicaciones.slice(0, 4).map((p) => (
                    <div key={`${p.id}${p.variacion}`}>
                      {p.permalink ? (
                        <a href={p.permalink} target="_blank" rel="noopener noreferrer">
                          {p.id}
                        </a>
                      ) : (
                        p.id
                      )}{" "}
                      <span className={`intg-etq ${p.logistica === "fulfillment" ? "full" : "drop"}`}>{p.logistica === "fulfillment" ? "Full" : "Drop"}</span>
                    </div>
                  ))}
                  {f.publicaciones.length > 4 ? <span style={{ color: "#64748b" }}>y {f.publicaciones.length - 4} mas</span> : null}
                </td>
                <td align="right">{entero(f.stockMeli)}</td>
                <td align="right">{f.precio ? `$${entero(f.precio)}` : "—"}</td>
                <td align="right" style={f.piezasVendidas ? { color: "#b91c1c", fontWeight: 600 } : undefined}>
                  {f.piezasVendidas ? `${entero(f.piezasVendidas)} pzs` : "—"}
                </td>
                <td style={{ fontSize: 12 }}>{f.motivo}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default SinAltaMeli;
